export enum LicenseState {
  VIGENTE = 'Vigente',
  VENCIDA = 'Vencida',
  SUSPENDIDA = 'Suspendida',
  CADUCADA = 'Caducada',
  SANCIONADO = 'Sancionado',
  PROXIMO_A_VENCER = 'Próximo a Vencer',
  ELIMINADAS = 'Eliminadas',
}